// Filter + sort drawer on collection pages (snippets/henk-collection-filter-drawer.liquid).
// Applying is a plain GET submit (one reload). While the drawer is open, every change
// fetches the section via the Section Rendering API to update the "N resultaten" button
// and the per-value counts, without reloading.
const drawer = document.getElementById('collection-filter-drawer');

if (drawer) {
  const form = drawer.querySelector('form');
  const submit = form.querySelector('[data-js-drawer-submit]');
  const reset = form.querySelector('[data-js-drawer-reset]');
  let controller;
  let debounce;

  let closeDrawer = () => drawer.close();

  // Browsers without the CSS overlay property (Firefox) drop the dialog from the top layer
  // on close, so the CSS slide-out never shows. Slide out first, then close.
  if (!CSS.supports('overlay', 'auto')) {
    closeDrawer = () => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return drawer.close();
      drawer.classList.add('is-closing');
      drawer.addEventListener('transitionend', function done(event) {
        if (event.propertyName !== 'translate' || event.pseudoElement) return;
        drawer.removeEventListener('transitionend', done);
        drawer.classList.remove('is-closing');
        drawer.close();
      });
    };
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });
    drawer.addEventListener('command', (event) => {
      if (event.command !== 'close') return;
      event.preventDefault();
      closeDrawer();
    });
  }

  // Fallback for browsers without invoker commands (command/commandfor)
  if (!('command' in HTMLButtonElement.prototype)) {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[commandfor="collection-filter-drawer"]');
      if (!button) return;
      if (button.getAttribute('command') === 'close') closeDrawer();
      else drawer.showModal();
    });
  }

  const formParams = () => {
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form)) {
      if (value !== '') params.append(key, value);
    }
    return params;
  };

  const inputKey = (input) => `${input.name}=${input.value}`;

  async function refresh() {
    controller?.abort();
    controller = new AbortController();

    const params = formParams();
    params.set('section_id', form.dataset.sectionId);
    submit.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${form.action}?${params}`, { signal: controller.signal });
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.getElementById('collection-filter-drawer');
      if (!fresh) return;

      submit.textContent = fresh.querySelector('[data-js-drawer-submit]').textContent;

      const freshInputs = new Map(
        [...fresh.querySelectorAll('input[type="checkbox"][data-js-filter-input]')].map((input) => [
          inputKey(input),
          input,
        ])
      );

      form.querySelectorAll('input[type="checkbox"][data-js-filter-input]').forEach((input) => {
        const freshInput = freshInputs.get(inputKey(input));
        if (!freshInput) return;
        input.disabled = freshInput.disabled && !input.checked;

        const count = input.closest('label')?.querySelector('[data-js-value-count]');
        const freshCount = freshInput.closest('label')?.querySelector('[data-js-value-count]');
        if (count && freshCount) count.textContent = freshCount.textContent;
      });
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    } finally {
      submit.removeAttribute('aria-busy');
    }
  }

  form.addEventListener('change', (event) => {
    if (event.target.type === 'number') return;
    refresh();
  });

  form.addEventListener('input', (event) => {
    if (event.target.type !== 'number') return;
    clearTimeout(debounce);
    debounce = setTimeout(refresh, 400);
  });

  reset.addEventListener('click', (event) => {
    event.preventDefault();
    form.querySelectorAll('[data-js-filter-input]').forEach((input) => {
      if (input.type === 'checkbox') input.checked = false;
      else input.value = '';
    });
    refresh();
  });

  // Don't send empty price fields on apply
  form.addEventListener('submit', () => {
    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') input.disabled = true;
    });
  });

  // Back/forward cache restores the page as it was at submit
  window.addEventListener('pageshow', () => {
    form.querySelectorAll('input[type="number"]').forEach((input) => (input.disabled = false));
  });
}
